<template>
  <div class="admin-layout">
    <button class="mobile-toggle" @click="toggleSidebar">
      <font-awesome-icon :icon="sidebarVisible ? ['fas', 'times'] : ['fas', 'bars']" />
    </button>

    <CmsSidebar :mobileVisible="sidebarVisible" @close="sidebarVisible = false" />

    <transition name="overlay-fade">
      <div class="overlay" v-if="sidebarVisible" @click="sidebarVisible = false" />
    </transition>

    <main class="content" :class="{ 'blurred': sidebarVisible }">
      <router-view />
    </main>
  </div>
</template>

<script>
import CmsSidebar from '@/components/cms/CmsSidebar.vue';

export default {
  components: { CmsSidebar },
  data() {
    return {
      sidebarVisible: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    }
  }
};
</script>

<style scoped lang="scss">
.admin-layout {
  display: flex;
  min-height: 100vh;
  background-color: $color-white;
  position: relative;
  overflow-x: hidden;
}

.content {
  flex-grow: 1;
  height: 91vh;
  overflow-y: auto;
  margin-bottom: 1rem;
  padding: 2rem;
  background-color: $color-background;
  transition: filter 0.3s ease;

  &.blurred {
    filter: blur(3px);
  }

  @media (max-width: 768px) {
    max-height: none;
    height: 100%;
    padding-bottom: 100px;
  }

}

.mobile-toggle {
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 44px;
    height: 44px;
    background-color: $color-background;
    border: none;
    border-radius: 50%;
    z-index: 101;
    font-size: 1.4rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    svg {
      width: 20px;
      height: 20px;
      color: $color-text;
    }
  }
}

.overlay {
  display: none;

  @media (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 99;
    cursor: pointer;
  }
}

.overlay-fade-enter-active,
.overlay-fade-leave-active {
  transition: opacity 0.3s ease;
}

.overlay-fade-enter-from,
.overlay-fade-leave-to {
  opacity: 0;
}

.overlay-fade-enter-to,
.overlay-fade-leave-from {
  opacity: 1;
}
</style>